import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('@/components/Homepage'),
			meta: { title: 'Home' },
		},
		// {
		// 	path: '/services',
		// 	name: 'services',
		// 	component: () => import('@/components/Services'),
		// 	meta: { title: 'Services' },
		// },
		{
			path: '/about-us',
			name: 'aboutus',
			component: () => import('@/components/AboutUs'),
			meta: { title: 'About Us' },
		},
		{
			path: '/contact-us',
			name: 'contactus',
			component: () => import('@/components/ContactUs'),
			meta: { title: 'Contact Us' },
		},
		{
			path: '/faq',
			name: 'faq',
			component: () => import('@/components/FAQ'),
			meta: { title: 'FAQ' },
		},
		{
			path: '/services/ocean',
			name: 'services-ocean',
			component: () => import('@/components/Services/Ocean/Ocean.vue'),
		},
		{
			path: '/services/automobile',
			name: 'services-automobile',
			component: () => import('@/components/Services/Automobile/Automobile.vue'),
		},
		{
			path: '/services/air-freight',
			name: 'services-air-freight',
			component: () => import('@/components/Services/Air/Air.vue'),
		},
		// {
		// 	path: '/services/import',
		// 	name: 'services-import',
		// 	component: () => import('@/components/Services/Import/Import.vue'),
		// },

		// {
		// 	name: '404',
		// 	path: '/resource-not-found',
		// 	component: () => import('@/components/404'),
		// 	meta: { title: 'Page not found' },
		// 	props: true,
		// },
		// {
		// 	path: '*',
		// 	redirect: to => {
		// 		return {
		// 			name: '404',
		// 			params: { badUrl: to.fullPath },
		// 		}
		// 	},
		// 	component: () => import('@/components/404'),
		// },
	],
});

export default router;
